
const businessServices = [
  {
    id: 1,
    icon: 'ri-building-4-line',
    title: 'Corporate Hotels',
    description: 'Premium business hotels in Canary Wharf, City of London, and Westminster with meeting facilities and executive lounges.',
  },
  {
    id: 2,
    icon: 'ri-team-line',
    title: 'Conference Venues',
    description: 'Access to top conference centres and meeting rooms across London, from intimate boardrooms to large event spaces.',
  },
  {
    id: 3,
    icon: 'ri-car-washing-line',
    title: 'Executive Transport',
    description: 'Professional chauffeur services with luxury vehicles for business meetings, client visits, and corporate events.',
  },
  {
    id: 4,
    icon: 'ri-restaurant-2-line',
    title: 'Halal Corporate Dining',
    description: 'Curated list of halal-certified restaurants suitable for business lunches and client entertainment in London.',
  },
];

export default function BusinessServices() {
  return (
    <section id="business" className="py-24 bg-[#1A1F2E]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#C9A961]/20 text-[#C9A961] text-sm font-medium rounded-full mb-4">
            Business Travel
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Business Trip & Seminar Services
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Professional travel arrangements for Pakistani business professionals visiting London for meetings, conferences, and corporate events.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {businessServices.map((service) => (
            <div
              key={service.id}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-14 h-14 bg-[#C9A961]/20 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#C9A961] transition-colors">
                <i className={`${service.icon} text-2xl text-[#C9A961] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-gray-400 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#C9A961]/20 to-transparent rounded-2xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                Planning a Corporate Event in London?
              </h3>
              <p className="text-gray-400 mb-6">
                From small team meetings to large-scale conferences, we handle all logistics including venue booking, accommodation, transport, and halal catering arrangements.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-gray-300">
                  <i className="ri-check-line text-[#C9A961]"></i>
                  Venue sourcing and negotiation
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <i className="ri-check-line text-[#C9A961]"></i>
                  Group accommodation booking
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <i className="ri-check-line text-[#C9A961]"></i>
                  Halal catering coordination
                </li>
                <li className="flex items-center gap-3 text-gray-300">
                  <i className="ri-check-line text-[#C9A961]"></i>
                  Airport transfers for delegates
                </li>
              </ul>
            </div>
            <div className="flex justify-center lg:justify-end">
              <button 
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="px-8 py-4 bg-[#C9A961] text-white rounded-lg font-semibold hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Corporate Quote
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
